<template>
  <div style="display: flex; flex-direction: column;padding-block: 25vh;">
    <v-card
        class="mx-auto"
        min-width="400"
        min-height="300"
        outlined>
      <v-card-title style="flex-direction: column;text-align: center;">
        <h1 style="
        justify-content: space-around;
        text-align: center;
        font-size: 1.75em;
        color: rgb(100 165 19);
        font-family: cursive;">
          Krasecology.ru
        </h1>
        <h2 style="font-weight: 400; padding-top: 16px;    font-size: 24px;">
          <span>Вход</span>
        </h2>
      </v-card-title>
      <v-card-text style="padding-bottom: 0;">
        <v-form
            ref="form"
            v-model="valid">
          <v-text-field
              v-model="name"
              :rules="[rules.required, rules.email]"
              label="Электронная почта"
              required
          ></v-text-field>
          <v-text-field
              v-model="pass"
              label="Пароль"
              required
              hide-details
              type="password"
              v-on:keyup.enter="login"
          ></v-text-field>
          <a style="font-size: 9pt" href="http://account.krasecology.ru/#/password-reset">Забыли пароль?</a>
        </v-form>
      </v-card-text>
      <v-card-actions style="margin-inline: 5px; margin-block: 5px">
        <v-spacer/>
        <v-btn :disabled="!valid" @click="login">
          Войти
        </v-btn>
      </v-card-actions>
    </v-card>
    <div style="margin-right: auto; margin-left: auto; padding: 10px; text-align: center; color:#232629; font-size: 11pt;">
      Ещё нет учётной записи?
      <a @click="registration">Зарегистрируйтесь</a>
      <br/> или
      <a style="font-weight: 700; font-size: 12pt" @click="logInAsGuest">войдите как гость</a>

    </div>
  </div>
</template>
<script>
import axios from "axios";
import {bus} from "@/main";


export default {
  data() {
    return {
      valid: false,
      name: '',
      pass: '',
      rules: {
        required: value => !!value || 'Обязательное поле.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Неверный адрес электронной почты.'
        },
      },
    }
  },
  methods: {
    login(e){
      e.preventDefault()
      axios
        .post("/eco-passport/auth/login",{login:this.name,pass:this.pass})
        .then(() => {
          if(this.$route.params.nextUrl != null) {
            this.$router.push(this.$route.params.nextUrl)
          } else {
            this.$router.push('/')
          }
        })
        .catch(e => {
          let errorMessage = {
            message: e.response.data,
            show: true,
            color: "red",
            centered: true,
            textColor: "#ffffff"
          }
          bus.$emit('message', errorMessage)
        });
    },
    registration() {
      this.$router.push({name: "registration", params: {nextUrl: "/login"}})
    },
    logInAsGuest() {
      this.$router.push({name: "guest"})
    }
  }
}
</script>
